import type { FormField } from '@funkit/connect-core'

/** Other countries' tax identifiers keep the server's ordinary text field. */
export function ssnLength(
  field: FormField,
  country: string | undefined,
): 4 | 9 | undefined {
  if (
    field.id !== 'TAX_IDENTIFIER' ||
    field.type !== 'TEXT' ||
    country?.toUpperCase() !== 'US'
  ) {
    return undefined
  }
  if (field.regex === undefined) {
    return 9
  }
  try {
    // The server pattern may be unanchored, where `\d{4}` also matches nine
    // digits; anchoring keeps a four-digit field from collecting a whole SSN.
    const pattern = new RegExp(`^(?:${field.regex})$`)
    if (pattern.test('1234')) {
      return 4
    }
    if (pattern.test('123456789')) {
      return 9
    }
  } catch {
    // Core reports unsupported server patterns; do not narrow their input here.
  }
  return undefined
}
